import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  totalPogs: 0,
  selected: 0,
  skuQty: 0,
  totalAdjCost: 0,
  acqCost: 0,
  freeAdjCost: 0,
  nonFreeAdjCost: 0,
};

export const ssTotalSlice = createSlice({
  name: "total",
  initialState,
  reducers: {
    setSSTotalDetails: (state, { payload }) => {
      state.totalPogs = payload?.TotalPogs ?? 0;
      state.selected = payload?.SelectedPogs ?? 0;
      state.skuQty = payload?.SkuQty ?? 0;
      state.totalAdjCost = payload?.TotalAdjCost ?? 0;
      state.freeAdjCost = payload?.FreeAdjCost ?? 0;
      state.nonFreeAdjCost = payload?.NonFreeAdjCost ?? 0;
      state.acqCost = payload?.AcqCost ?? 0;
    },
  },
});

export const { setSSTotalDetails } = ssTotalSlice.actions;

export default ssTotalSlice.reducer;
